import React from 'react';
import { Provider } from 'react-redux';
import { HashRouter, Routes, Route } from 'react-router-dom';
import configureStore from './store';
import App from './containers/App';
import { APP_NAME } from './ApiUrl';
import { withRouter } from './util/withRouter';

export const store = configureStore();

class MainAppContent extends React.Component {
  componentDidMount() {
    this.updateTitle();
  }

  componentDidUpdate(prevProps) {
    // Only update if location changed
    if (prevProps.location.hash !== this.props.location.hash) {
      this.updateTitle();
    }
  }

  updateTitle = () => {
    const hash = this.props.location.hash;
    let title = '';
    switch (true) {
      case hash.includes('dashboard'):
        title = 'Dashboard';
        break;
      case hash.includes('support-chat'):
        title = 'Support Chat';
        break;
      case hash.includes('customers'):
        title = 'Customers';
        break;
      case hash.includes('driver'):
        title = 'Drivers';
        break;
      case hash.includes('bike-types'):
        title = 'Car Types';
        break;
      case hash.includes('trips'):
        title = 'Trips';
        break;
      case hash.includes('promo-codes'):
        title = 'Promo codes';
        break;
      case hash.includes('contentPages'):
        title = 'Content Pages';
        break;
      case hash.includes('faq'):
        title = 'FAQ';
        break;
      case hash.includes('notification'):
        title = 'Push Notification';
        break;
      case hash.includes('notifications'):
        title = 'System Notifications';
        break;
      case hash.includes('users'):
        title = 'Admin Settings';
        break;
      case hash.includes('partners'):
        title = 'Partners Settings';
        break;
      case hash.includes('settings'):
        title = 'Settings';
        break;
      case hash.includes('invoice'):
        title = 'invoice';
        break;
      default:
        title = 'Admin';
        break;
    }
    document.title = `${APP_NAME} | ${title}`;
  };

  render() {
    return (
      <Routes>
        <Route path="/*" element={<App />} />
      </Routes>
    );
  }
}

// Wrap the content component with withRouter
const MainAppContentWithRouter = withRouter(MainAppContent);

// Main wrapper component
class MainApp extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <HashRouter>
          <MainAppContentWithRouter />
        </HashRouter>
      </Provider>
    );
  }
}

export default MainApp;
